var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.875H14.9062V3.625C14.9062 1.96797 13.5633 0.625 11.9062 0.625H6.09375C4.43672 0.625 3.09375 1.96797 3.09375 3.625V8.875H1.5C1.08516 8.875 0.75 9.21016 0.75 9.625V18.625C0.75 19.0398 1.08516 19.375 1.5 19.375H16.5C16.9148 19.375 17.25 19.0398 17.25 18.625V9.625C17.25 9.21016 16.9148 8.875 16.5 8.875ZM4.78125 3.625C4.78125 2.90078 5.36953 2.3125 6.09375 2.3125H11.9062C12.6305 2.3125 13.2188 2.90078 13.2188 3.625V8.875H4.78125V3.625ZM15.5625 17.6875H2.4375V10.5625H15.5625V17.6875ZM8.34375 14.4297V15.6719C8.34375 15.775 8.42812 15.8594 8.53125 15.8594H9.46875C9.57187 15.8594 9.65625 15.775 9.65625 15.6719V14.4297C9.84972 14.2908 9.99413 14.0941 10.0687 13.8679C10.1432 13.6417 10.1441 13.3977 10.0711 13.1709C9.99818 12.9442 9.85516 12.7465 9.66268 12.6062C9.47019 12.466 9.23817 12.3904 9 12.3904C8.76183 12.3904 8.52981 12.466 8.33732 12.6062C8.14484 12.7465 8.00182 12.9442 7.92886 13.1709C7.8559 13.3977 7.85676 13.6417 7.93132 13.8679C8.00588 14.0941 8.15028 14.2908 8.34375 14.4297Z",
    fill: "#8F95B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLIcon);
export default __webpack_public_path__ + "static/media/l-icon.5b35643682f2f6cb32aa3b28fd2dc278.svg";
export { ForwardRef as ReactComponent };